import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";
import axiosLogin from "global/helpers/axiosLogin";

// export const wsPostValidaOnline = (dtoTurno, nextStep) => {
//   axiosAutoCheck().then((respuesta) => {
//     respuesta
//       .post(`/turno/validarOnline`,  dtoTurno)
//       .then((resp) => {
//         if (nextStep) nextStep(true,resp.data);
//       })
//       .catch((err) => {
//         if (nextStep) nextStep(false, err);
//       });
//   });
// };

export const wsPostValidaOnline = (dtoTurno, nextStep) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .post(`/his/turnos/validarOnline`,  dtoTurno)
      .then((resp) => {
        if (nextStep) nextStep(true,resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err);
      });
  });
};

export const wsGetValidaOnlineToken = (idTurno, nextStep) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/turnos/verifaValidarOnLineToken/${idTurno}`)
      .then((resp) => {
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, { token: true });
      });
  });
};
